import { GridColumnType } from "../../../../data/gridColumnType";

export const AuditlogConfig = {
  columns: [
    {
      name: "Date Time",
      fieldName: "DateTime",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Description",
      fieldName: "Description",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Updated By",
      fieldName: "UpdatedBy",
      allowShort: false,
      colType: GridColumnType.Text,
    },
  ],
};
